var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSweetheartRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 110,
    viewBox: "0 0 12 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50024 0L0.000212669 1.5C8.37731 44.1615 9.60703 65.2701 0.000237465 108.5L4.50024 110C14.8335 68.1843 13.5757 43.9955 4.50024 0Z",
    fill: "#71AD80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweetheartRight);
export default __webpack_public_path__ + "static/media/sweetheart-right.5c8f759f36f5464b7cb944b9decae8d9.svg";
export { ForwardRef as ReactComponent };